import { LoadingOutlined } from "@ant-design/icons"
import { Spin, Typography } from "antd"
import { useTranslation } from "react-i18next"

import { OVERLAY_STATUS } from "../../utils/hydrate"

import styles from "./profileStatusOverlay.module.less"

const { Title, Text } = Typography

// Copy for every server-driven waiting state the wizard can be locked into.
// AWAITING_ACTIVATION is the post-first-submit window before any program is
// live (CHA1-2085); UPDATE_IN_PROGRESS is any open Profile-update record
// (§11.14). Keys are OVERLAY_STATUS values, so callers (this overlay,
// ConfigureTabs' lock tooltip) share one set of titles.
export const OVERLAY_STATUS_COPY = {
  [OVERLAY_STATUS.AWAITING_ACTIVATION]: {
    title: "Enrollment in progress",
    body: "We're processing your enrollment request. This usually takes 1 business day. We'll email you when Digital Receipt is active for your account.",
    tag: "Pending…"
  },
  [OVERLAY_STATUS.UPDATE_IN_PROGRESS]: {
    title: "Profile update under review",
    body: "Your changes are being reviewed. Editing will re-open once they're processed.",
    tag: "Under review"
  }
}

// Blurred overlay pinned over the wizard's main pane while the profile is
// locked by the server. Replaces the older yellow UnderReviewBanner + the
// ConfigureSummary "extra summary page" (CHA1-2083) with a single visual
// treatment — form stays visible underneath so the merchant can still read
// their answers, but every input is disabled by the caller (formDisabled).
const ProfileStatusOverlay = ({ status }) => {
  const { t } = useTranslation()
  const copy = OVERLAY_STATUS_COPY[status]
  if (!copy) return null

  return (
    <div className={styles.overlay} aria-live="polite">
      <div className={styles.content}>
        <Spin indicator={<LoadingOutlined className={styles.spinner} spin />} />
        <Title level={4} className={styles.title}>
          {t(copy.title)}
        </Title>
        <Text type="secondary" className={styles.body}>
          {t(copy.body)}
        </Text>
        <span className={styles.tag}>
          <LoadingOutlined spin />
          {t(copy.tag)}
        </span>
      </div>
    </div>
  )
}

export default ProfileStatusOverlay
